import SliderStyle from "../../components/styles/slider";
import SliderCaraCerdasMobile from "../UserInterface/SliderCaraCerdasMobile";
import CardComponentCaraCerdas from "./CardComponentCaraCerdas";

const CaraCerdasCard = () => {
  return (
    <div className="CaraCerdas-card-wrapper">
      <div className="CaraCerdas-card-container">
        <div className="CaraCerdas-card-cerdas-desktop">
          <CardComponentCaraCerdas relatedTo={undefined} />
        </div>
        <div className="CaraCerdas-card-cerdas-mobile">
          <SliderCaraCerdasMobile relatedTo={undefined} />
        </div>
        <SliderStyle />
        <style jsx global>{`
          .CaraCerdas-card-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .CaraCerdas-card-container {
            width: 100%;
            max-width: 960px;
            min-height: 400px;
            display: flex;
            flex-direction: column;
            margin: 24px 0px;
          }
          .CaraCerdas-card-cerdas-desktop {
            display: flex;
            align-content: flex-start;
            flex-direction: row;
          }
          .CaraCerdas-card-cerdas-mobile {
            display: none;
          }
          @media only screen and (max-width: 700px) {
            .CaraCerdas-card-container {
              margin: 0px 16px;
            }
            .CaraCerdas-card-cerdas-desktop {
              display: none;
            }
            .CaraCerdas-card-cerdas-mobile {
              align-content: flex-start;
              display: flex;
              margin: 24px 0px;
              flex-direction: row;
              overflow-x: scroll;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default CaraCerdasCard;
